"use client";
export { SliderNav as default } from "../../../_Builtin/Slider";
